exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5d538c53] .drawer{margin:0;height:100vh;max-height:100vh;border-radius:0;transition:transform .2s}[data-v-5d538c53] .none-enter-active,[data-v-5d538c53] .none-leave-active{transform:translateX(100%)}.v-dialog__content[data-v-5d538c53]{justify-content:flex-end}.emailLabel[data-v-5d538c53]{color:#1d2231;font-size:1rem}", ""]);

// exports
